import * as CONSTRAINTS from './repeaterConstraints'
import deepEqual from 'deep-equal'
import store from '../../store'

const getProps = (props = {}) => {
  return {
    errorMessage: { type: "text", value: "", label: "Error Message" },
    ...props
  }
}

export default {
  atLeastSomeStateMustBe: {
    fn: 'atLeastSomeStateMustBe',
    name: 'At least X rows must have Y state',
    props: getProps({
      minNumber: {
        type: 'range',
        label: 'How many rows are required to have this state?',
        name: 'minNumber',
        minValue: 0,
        maxValue: 100,
        value: 0
      },
      state: {
        label: 'Which state is required?',
        name: 'state',
        width: '40%',
        type: 'stateSelect',
        value: process.env.STATE_ABBR
      }
    })
  },
  mustBeLessThanOrEqualToColumn: {
    fn: 'mustBeLessThanOrEqualToColumn',
    name: 'Value must be less than or equal to column X',
    props: getProps({
      column: {
        type: 'srcRepeaterColumn',
        label: 'Which column must this field be less than?',
        value: ''
      }
    })
  },
  maxNumberOfSelectedOption: {
    fn: 'maxNumberOfSelectedOption',
    name: 'Maximum Number of Selected Options',
    props: {
      config: {
        label: 'Put the max number of selected options per repeater for the provided options. Leave it blank to allow unlimited options.',
        name: 'config',
        type: 'selectOptionConstrainer',
        value: {}
      }
    }
  },
  minNumberOfSelectedOption: {
    fn: 'minNumberOfSelectedOption',
    name: 'Minimum Number of Selected Options',
    props: {
      config: {
        label: 'Put the minimum number of selected options per repeater for the provided options. Leave it blank to allow unlimited options.',
        name: 'config',
        type: 'selectOptionConstrainer',
        value: {}
      }
    }
  },
  xMayNotEqualY: {
    fn: 'xMayNotEqualY',
    name: 'Column X may not equal column Y',
    props: getProps({
      column: {
        type: 'srcRepeaterColumn',
        label: 'Which column may this column not be equal to?',
        value: ''
      }
    })
  },
  minNumberChecked: {
    fn: 'minNumberChecked',
    name: 'Must be checked in a minimum number of rows',
    props: getProps({
      minNumber: {
        type: 'range',
        label: 'How many rows must have this checkbox checked?',
        name: 'minNumber',
        minValue: 0,
        maxValue: 100,
        value: 0
      },
    })
  },
  minNumberUnchecked: {
    fn: 'minNumberUnchecked',
    name: 'Must be unchecked in a minimum number of rows',
    props: getProps({
      minNumber: {
        type: 'range',
        label: 'How many rows must have this checkbox unchecked',
        name: 'minNumber',
        minValue: 0,
        maxValue: 100,
        value: 0
      },
    })
  }
}

export const validateRepeaterConstraints = (columns, repeater) =>
  new Promise((resolve, reject) => {
    const columnPromises = columns.map(
      col =>
        new Promise((columnResolve, columnReject) => {
          const constraintPromises = col.repeaterConstraints.map(
            constraint =>
              new Promise((constraintResolve, constrainReject) => {
                CONSTRAINTS[constraint.fn](repeater, col, constraint.props).then(res => {
                  constraintResolve({...res, fieldId: col.fieldId, constraint: constraint.fn})
                })
              })
          )
          Promise.all(constraintPromises).then(values => columnResolve(values))
        })
    )
    Promise.all(columnPromises).then(values => resolve(values.flatMap(v=>v)))
  })

export const atLeastSomeStateMustBe = (repeater, field, props = {}) =>
  new Promise((resolve, reject) => {
    const states = repeater.value.map(row => row[field.fieldId].STATE)
    const numWithState = states.filter(state => state === props.state).length
    if(numWithState >= props.minNumber){
      resolve({
        isValid: true,
        errorMessage: ''
      })
    }else{
      resolve({
        isValid: false,
        errorMessage: props.errorMessage || `At least ${props.minNumber} row(s) must have a(an) ${props.state} address.`
      })
    }
  })

export const mustBeLessThanOrEqualToColumn = (repeater, field, props = {}) => (
  new Promise((resolve, reject) => {
    const isValids = repeater.value.map(row => {
      const currentField = row[field.fieldId]
      const fieldToCompare = row[props.column]
      if(currentField !== undefined && fieldToCompare !== undefined){
        const num1 = parseInt(currentField.replace(/,/g, ''), 10)
        const num2 = parseInt(fieldToCompare.replace(/,/g, ''), 10)
        return num1 <= num2
      }else{
        return false;
      }
    })
    const isValid = !isValids.some(v=>v === false)
    const fieldToCompare = store.getState().wizard.wizard.fields[props.column] || {}
    resolve({
      isValid,
      errorMessage: isValid ? '' : props.errorMessage || `${field.label} must be less than ${fieldToCompare.label}`
    })
  })
)

export const maxNumberOfSelectedOption = (repeater, field, props = {}) =>
new Promise((resolve, reject) => {
  const numOptions = repeater.value.reduce((obj, row) => {
    const hasValidateRepeater = !!repeater.businessRules.find((item) => item.fn === "validateRepeaterFields")
    const isExempt = hasValidateRepeater && !!repeater.businessRules.find((item) => item.fn === "validateRepeaterFields").props.skipDeletedRows ? row._statusId === 3 : false;
    if(isExempt) return obj
      if (field.type === 'MultiComplete') {
        const val = row[field.fieldId]
        let newObj = { ...obj }
        val.forEach((v) => {
          newObj = {
            ...newObj,
            [v]: newObj[v] !== undefined ? newObj[v] + (isExempt ? 0 : 1) : 1,
          }
        }, {})
        return newObj
      } else {
        return {
          ...obj,
          [row[field.fieldId]]:
            obj[row[field.fieldId]] !== undefined ? obj[row[field.fieldId]] + (isExempt ? 0 : 1) : 1,
        }
      }
    }, {})

    const results = field.options
      .map((option) => {
        let maxNum =
          typeof props.config[option.value] !== 'object'
            ? props.config[option.value]
            : props.config[option.value].num

        let errorMessage =
          typeof props.config[option.value] !== 'object' ? '' : props.config[option.value].error

        if (maxNum) {
          if ((numOptions[option.value] || 0) <= maxNum) {
            return { isValid: true, errorMessage: '' }
          } else {
            return {
              isValid: false,
              errorMessage:
                errorMessage ||
                `You cannot have more than ${maxNum} of ${option.label}`,
            }
          }
        } else {
          return undefined
        }
      })
      .filter((x) => x)

    if (results.every((result) => result.isValid)) {
      resolve({
        isValid: true,
        errorMessage: '',
      })
    } else {
      resolve({
        isValid: false,
        errorMessage: results
          .map((result) => result.errorMessage)
          .filter((x) => x)
          .join('\n'),
      })
    }
  })

export const minNumberOfSelectedOption = (repeater, field, props = {}) =>
  new Promise((resolve, reject) => {
    const numOptions = repeater.value.reduce((obj, row) => {
      const hasValidateRepeater = !!repeater.businessRules.find((item) => item.fn === "validateRepeaterFields")
      const isExempt = hasValidateRepeater && !!repeater.businessRules.find((item) => item.fn === "validateRepeaterFields").props.skipDeletedRows ? row._statusId === 3 : false;
      if(isExempt) return obj
      if (field.type === 'MultiComplete') {
        const val = row[field.fieldId]
        let newObj = { ...obj }
        val.forEach((v) => {
          newObj = {
            ...newObj,
            [v]: newObj[v] !== undefined ? newObj[v] + (isExempt ? 0 : 1) : 1,
          }
        }, {})
        return newObj
      } else {
        return {
          ...obj,
          [row[field.fieldId]]:
            obj[row[field.fieldId]] !== undefined ? obj[row[field.fieldId]] + (isExempt ? 0 : 1) : 1,
        }
      }
    }, {})

    const results = field.options
      .map((option) => {
        let maxNum =
          typeof props.config[option.value] !== 'object'
            ? props.config[option.value]
            : props.config[option.value].num

        let errorMessage =
          typeof props.config[option.value] !== 'object' ? '' : props.config[option.value].error

        if (maxNum) {
          if ((numOptions[option.value] || 0) >= maxNum) {
            return { isValid: true, errorMessage: '' }
          } else {
            return {
              isValid: false,
              errorMessage: errorMessage || `You must have at least ${props.config[option.value]} of ${
                option.label
              }`,
            }
          }
        } else {
          return undefined
        }
      })
      .filter((x) => x)

    if (results.every((result) => result.isValid)) {
      resolve({
        isValid: true,
        errorMessage: '',
      })
    } else {
      resolve({
        isValid: false,
        errorMessage: [
          results
            .map((result) => result.errorMessage)
            .filter((x) => x)
            .join('\n'),
        ],
      })
    }
  })

export const xMayNotEqualY = (repeater, field, props = {}) => (
  new Promise((resolve, reject) => {
    const isValids = repeater.value.map(row => {
      const currentField = row[field.fieldId]
      const fieldToCompare = row[props.column]
      if(currentField !== undefined && fieldToCompare !== undefined){
        return deepEqual(currentField, fieldToCompare)
      }else{
        return false;
      }
    })
    const isValid = !isValids.some(x=>x === false)
    const fieldToCompare = store.getState().wizard.wizard.fields[props.column] || {}
    resolve({
      isValid,
      errorMessage: isValid ? '' : props.errorMessage || `"${field.label}" may not be the same as "${fieldToCompare.label}"`
    })
  })
)

export const minNumberChecked = (repeater, field, props = {}) => (
  new Promise((resolve, reject) => {
    const numChecked = repeater.value.reduce((num, row) => row[field.fieldId] ? num + 1 : num, 0)
    if(numChecked >= props.minNumber){
      resolve({
        isValid: true,
        errorMessage: ""
      })
    }else{
      resolve({
        isValid: false,
        errorMessage: `"${field.label}" must be checked in at least ${props.minNumber} row(s).`
      })
    }
  })
)

export const minNumberUnchecked = (repeater, field, props = {}) => (
  new Promise((resolve, reject) => {
    const numUnchecked = repeater.value.reduce((num, row) => !row[field.fieldId] ? num + 1 : num, 0)
    if(numUnchecked >= props.minNumber){
      resolve({
        isValid: true,
        errorMessage: ""
      })
    }else{
      resolve({
        isValid: false,
        errorMessage: `"${field.label}" must not be checked in at least ${props.minNumber} row(s).`
      })
    }
  })
)



// WEBPACK FOOTER //
// ./src/components/Wizard2/repeaterConstraints.js